// The physical file format (PDF/DOCX/JPG/...) — never a business concept.
// `ProjectAttachment.file_type` looks like a "type" field but is a legacy
// document *category* enum (Legal Documents/Proposal/Draft/Contract/...),
// with 5="Draft" as the bucket every untyped upload defaults to; showing its
// label in a "file type" column is how a PDF's Type cell ends up reading
// "Draft". The extension is the only thing that actually answers "what kind
// of file is this" for both file sources — an Attachment carries no
// business-category field at all, and a document's own is a workflow/
// category concept covered separately by Document Type and Status.
export const fileFormatLabel = (file: {
  name: string
  mimeType?: string | null
}): string | undefined => {
  const extension = file.name.split(".").pop()
  if (extension && extension !== file.name) {
    return extension.toUpperCase()
  }
  const subtype = file.mimeType?.split("/").pop()
  return subtype ? subtype.toUpperCase() : undefined
}
